module.exports = __webpack_public_path__ + "assets/img/b2ed-om.svg";